import React from 'react';
import Check from "./check";
import {observer} from "mobx-react";
import {useCallback, useEffect} from "react";
import axios from "axios";
import store from "../../store";

function Checks() {
  useEffect(() => {
    fetchSystemChecks();
    fetchGeneralChecks();
  }, []);

  const fetchGeneralChecks = useCallback(async () => {
    const general_tests_results = await axios.get(`${process.env.REACT_APP_BASE_URL_API}/monitoring/checks/general`);
    store.addChecks(general_tests_results.data);
  }, []);

  const fetchSystemChecks = useCallback(async () => {
    const system_tests_results = await axios.get(`${process.env.REACT_APP_BASE_URL_API}/monitoring/checks/system`);
    store.addChecks(system_tests_results.data);
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 2xl:grid-cols-6 gap-10 p-4">
      {
        store.checks.length > 0 && store.checks.map(check => (<Check name={check.test_name} key={check.test_name} status={check._status} checks={check._checks} errors={check._errors}/>))
      }
    </div>
  );
}

export default observer(Checks);
